import { Modal } from '@snsw/react-component-library';
import React, { useState } from 'react';
import { useToggle } from 'react-use';
import { LabelledValue } from 'shared/components/labelledValue/LabelledValue';

const ConfirmDialog = ({ isOpen, close, onRemove, item }) => {
  const onConfirmRemove = () => {
    onRemove(item.rsn);
    close();
  };
  return (
    <>
      {isOpen && (
        <Modal
          title="Are you sure you want to remove this item?"
          buttons={[
            { text: 'Remove', onClick: onConfirmRemove },
            { text: 'Cancel', onClick: close },
          ]}
        >
          <p>
            You will not be able to renew this item in the future. If you remove an item, you will need to reapply for
            registration before you can use it again.
          </p>
          <LabelledValue label="Plant item:" value={item.description} />
          {item.type && <LabelledValue label="Type:" value={item.type} />}
          {item.location && <LabelledValue label="Location of item:" value={item.location} />}
          {item.registrationNumber && <LabelledValue label="Registration number:" value={item.registrationNumber} />}
          {item.serialNumber && <LabelledValue label="Serial number:" value={item.serialNumber} />}
        </Modal>
      )}
    </>
  );
};

export const useConfirmRemovalDialog = (onRemove) => {
  const [isOpen, toggle] = useToggle(false);
  const [item, setItem] = useState();

  const close = () => {
    toggle(false);
  };

  const openDialog = (item) => {
    setItem(item);
    toggle(true);
  };

  const dialogComponent = <ConfirmDialog isOpen={isOpen} close={close} onRemove={onRemove} item={item} />;

  return { openDialog, dialogComponent };
};
